import './style.scss';

import { motion } from 'framer-motion';
import React from 'react';

interface IFieldHintProps {
  comment?: React.ReactNode;
  errorMessage?: string;
  hideErrorMessageText?: boolean;
}

export const FieldHints = ({
  comment,
  errorMessage,
  hideErrorMessageText = false,
}: IFieldHintProps) => {
  return (
    <>
      {comment && !errorMessage ? (
        <motion.div className="mm-field-comment">
          <motion.span
            initial={{ height: 0, opacity: 0 }}
            animate={{ height: 'auto', opacity: 1 }}
            key="comment-message"
            className="w-full"
          >
            {comment}
          </motion.span>
        </motion.div>
      ) : null}
      {errorMessage && !hideErrorMessageText ? (
        <motion.div className="mm-field-error">
          <motion.span
            initial={{ height: 0, opacity: 0 }}
            animate={{ height: 'auto', opacity: 1 }}
            key="error-message"
          >
            {errorMessage}
          </motion.span>
        </motion.div>
      ) : null}
    </>
  );
};
